// extracted by mini-css-extract-plugin
export default {"container":"MM-z","dimension":"NM-z","dimensionLabels":"OM-z"};